import { Directive, ElementRef, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
	selector: '[smoothHeight]',
	host: { '[style.overflow]': '"hidden"' }
})
export class SmoothHeightAnimationDirective implements OnChanges {

	@Input() smoothHeight : any;
	pulse! : boolean;
	startHeight! : number;

	constructor(private element: ElementRef) { }

	@HostBinding('@grow')
	get grow() {
		return {
			value: this.pulse,
			params: { startHeight: this.startHeight }
		};
	}

	setStartHeight() {
		this.startHeight = this.element.nativeElement.clientHeight;
	}

	ngOnChanges(changes: SimpleChanges) {
		this.setStartHeight();
		this.pulse = !this.pulse;
	}
}
